<template>
  <section class="categoryManage" id="categoryManage">
    <viewTitle
      title="业务管理 / 审批跳过情况汇总 / 类别管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button type="primary" @click="modifyTpl('', 'add')" size="small">
          新建类别
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="类别名称">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.update_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    @click.native.stop="modifyTpl(scope.row, 'edit')"
                    >修改</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          size="small"
          :class="dialogParams.type === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.type === 'del' ? 'danger' : 'primary'"
          @click="confirm"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.showModify"
      width="45%"
      :close-on-click-modal="false"
      :title="dialogParams.typeModify === 'add' ? '新建类别' : '编辑类别'"
    >
      <div>
        <el-form label-width="100px">
          <el-form-item
            label="类别名称"
            :rules="[{ required: true, message: '' }]"
          >
            <el-input
              v-model="modifyParams.name"
              placeholder="请输入类别名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          <span>取 消</span>
        </el-button>
        <el-button type="primary" @click="save" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      rowDataObj: {},
      params: {
        keyword: "", // 关键字搜索
        state: "" // 状态
      },
      dialogParams: {
        show: false,
        title: "",
        content: "",
        type: "",
        showModify: false, // 编辑
        typeModify: "" // 编辑/添加
      },
      modifyParams: {
        id: 0, // id
        name: "" // 类别名称
      },
      tableData: [] // 表格数据
    };
  },

  mixins: [mixinTableLyout],

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    this.getList();
  },

  async activated() {},

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_class",
        data: {
          page_size: this.pageSize,
          page: this.page
        }
      });
      this.tableData = dataObj.data.data.items;
      this.count = dataObj.data.data.total;
    },

    // 查看详情
    modifyTpl(row, tag) {
      console.log(row);
      this.dialogParams.showModify = true;
      this.dialogParams.typeModify = tag;
      this.rowDataObj = row;

      if (tag === "edit") {
        this.modifyParams.id = row.id;
        this.modifyParams.name = row.name;
      }
    },

    // 删除/禁用启用
    delOrEnable(row, tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
      this.rowDataObj = row;
      if (tag === "del") {
        this.dialogParams.content = `确认要删除“<span class="color67">${this.rowDataObj.name}</span>”类别吗？<br />
        <span class="color67">删除后不可恢复！</span>`;
      }
    },

    // 确认删除/禁用启用
    confirm() {
      this.dialogParams.show = false;
      let url = "";
      if (this.dialogParams.type === "del") {
        url = "/api/psummary/admin/delete_class";
      }
      this.$common
        .http({
          url: url,
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res);
          if (this.dialogParams.type === "del") {
            this.$common.pcToastSuccess(
              `已成功删除“${this.rowDataObj.name}”类别。`
            );
            // this.dialogParams.content = `已成功删除“<span class="color67">${this.rowDataObj.name}</span>”类别。`;
          }
          // this.dialogParams.show = true;
          // this.dialogParams.title = "操作成功";
          this.getList();
          // setTimeout(() => {
          //   this.dialogParams.show = false;
          // }, 1500);
        });
    },

    // 保存表单
    save() {
      console.log("保存", this.modifyParams);
      if (this.modifyParams.name.trim() === "") {
        this.$common.pcToastFail("类别名称不能为空");
        return false;
      }
      let url = "";
      let data = {};
      if (this.dialogParams.typeModify === "add") {
        url = "/api/psummary/admin/create_class";
        data = {
          name: this.modifyParams.name
        };
      } else {
        url = "/api/psummary/admin/update_class";
        data = {
          id: this.modifyParams.id,
          name: this.modifyParams.name
        };
      }

      this.$common
        .http({
          url: url,
          data: data
        })
        .then(res => {
          console.log(res);
          this.dialogParams.showModify = false;
          if (res.data.data) {
            if (this.dialogParams.typeModify === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          // 重置表单
          this.modifyParams.id = 0;
          this.modifyParams.name = "";
        });
    },

    // 取消
    cancel() {
      this.dialogParams.showModify = false;
      this.modifyParams.id = 0;
      this.modifyParams.name = "";
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.categoryManage {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
.el-checkbox,
.el-checkbox__input {
  white-space: normal;
  word-break: break-all;
}
</style>
<style lang="less">
#categoryManage .el-checkbox__label {
  width: 70%;
  vertical-align: text-top;
}
</style>
